<template>
  <section :class="['no-results', variant]">
    <h1 v-if="headline" class="headline">{{ headline }}</h1>
    <h2 v-if="subline" class="subline">{{ subline }}</h2>

    <Illustration v-bind="{ alt }" class="image" :name="illustration" />

    <LcButton v-if="buttonText" @click="emit('cta-click')">
      {{ buttonText }}
    </LcButton>
  </section>
</template>

<script lang="ts" setup>
type NoResultsEmits = {
  (e: 'cta-click'): void
}

type NoResultsProps = {
  alt?: string
  buttonText?: string
  headline?: string
  illustration?: string
  subline?: string
  variant?: 'default' | 'outlined'
}

const emit = defineEmits<NoResultsEmits>()

const {
  alt = 'Warning sign.',
  illustration = 'no-result',
  variant = 'default',
} = defineProps<NoResultsProps>()
</script>

<style lang="scss" scoped>
.no-results {
  display: flex;
  flex-direction: column;
  align-items: center;

  .headline,
  .subline {
    @include token-headline-h4-headline;
  }

  .subline {
    margin-top: token('size/space/gap/200');
  }

  .image {
    margin: token('size/space/gap/300') 0;
  }

  &.outlined {
    padding: token('size/space/gap/300') token('size/space/gap/200');
    border: token('size/border/100') token('color/border/primary/primary') solid;
    border-radius: token('size/radius/l');

    .headline,
    .subline {
      margin: 0;
    }

    .image {
      margin: token('size/space/gap/200') 0;
    }
  }
}
</style>
